<template>
  <modal v-model="displayData" effect="zoom" :backdrop="false" @opened="resetModal()">
    <div slot="modal-header" class="modal-header">
      <span class="modal-title" style="font-size:16px">Please complete the captcha to prove you are not a robot.</span>
    </div>
    <div class="container-fluid component">
      <div v-show="!customMailAuth" id="recaptcha">
        <vue-recaptcha
          :sitekey="recaptchaSitekey"
          @verify="onCaptchaVerify($event)"
          @expired="onCaptchaExpired()"
          @render="onCaptchaLoaded()"
        />
      </div>
      <div v-if="customMailAuth" id="mailAuth">
        <div v-if="loadMsg1" id="msg1">
          <p>
            To submit this request, please click the Generate Token button below. A token will be sent to email ID (<b
              >{{ user.email }}</b
            >) used in the form you are submitting. This token is a one-time use that is only valid for 30 minutes.
          </p>
        </div>
        <div v-if="loadMsg2" id="msg2">
          <p>Token generated successfully and sent to email. Enter the token below and click submit.</p>
          <input v-model="customRecaptchaValue" type="text" class="form-control" name="customRecaptchaValue" />
        </div>
      </div>
      <div v-if="!captchaPassed && $v.captchaPassed.$dirty" id="recaptcha" class="text-danger">
        We need to verify you are not a robot
      </div>
    </div>
    <div v-if="!customMailAuth" slot="modal-footer" class="modal-footer">
      <button id="ok" type="button" class="btn btn-sm btn-default" @click="$emit('closeModal')">Cancel</button>
      <button id="ok" type="button" class="btn btn-sm btn-primary" @click="submit()">Submit</button>
    </div>
    <div v-if="customMailAuth" slot="modal-footer" class="modal-footer">
      <button type="button" class="btn btn-sm btn-default" @click="$emit('closeModal')">Cancel</button>
      <button v-if="loadMsg1" type="button" class="btn btn-sm btn-primary" @click="loadMsgWindow2()">
        Generate Tokens
      </button>
      <button v-if="loadMsg2" type="button" class="btn btn-sm btn-default" @click="generateToken()">
        Regenerate Tokens
      </button>
      <button v-if="loadMsg2" type="button" class="btn btn-sm btn-primary" @click="submit()">Submit</button>
    </div>
    <div v-if="registrationFailed" id="mailAuth">
      <span class="fa fa-exclamation text-warning fa-lg" />
      Your request could not be submitted due to an intermittent connection issue! Please try submitting your request
      again after sometime.
    </div>
  </modal>
</template>
<script>
import modal from "build-ui-x/src/Modal";
import VueRecaptcha from "vue-recaptcha";
import { requiredIf } from "vuelidate/lib/validators";
import { generateToken } from "@/services/endpointsService";
import { mapState } from "vuex";

export default {
  components: {
    modal,
    VueRecaptcha
  },
  props: {
    displayData: {
      type: Boolean,
      default: null
    }
  },
  data() {
    return {
      showModal: false,
      captchaPassed: false,
      recaptchaResponseData: null,
      customMailAuth: true,
      customRecaptchaValue: "",
      loadMsg1: true,
      loadMsg2: false,
      registrationFailed: false
    };
  },
  computed: {
    ...mapState("user", ["user"]),
    ...mapState("env", ["recaptchaSitekey"])
  },
  validations: {
    captchaPassed: {
      required: requiredIf(function(vm) {
        return !this.customMailAuth && vm && vm.captchaPassed;
      })
    },
    customRecaptchaValue: {
      required: requiredIf(function(vm) {
        return this.customMailAuth && vm && vm.captchaPassed;
      })
    }
  },
  methods: {
    onCaptchaVerify(response) {
      this.captchaPassed = true;
      this.recaptchaResponseData = response;
    },
    onCaptchaExpired() {
      this.captchaPassed = false;
      this.recaptchaResponseData = null;
    },
    onCaptchaLoaded() {
      this.customMailAuth = false;
    },
    submit() {
      this.$v.$touch();

      if (this.customMailAuth && this.customRecaptchaValue.length < 9) {
        return;
      }

      if (!this.captchaPassed && !this.customMailAuth) {
        return;
      }

      if (this.customMailAuth) {
        //laoding email authentication
        this.$emit("recaptchaResponseData", this.customRecaptchaValue);
      } else {
        //load recaptcha response
        this.$emit("recaptchaResponseData", this.recaptchaResponseData);
      }
      this.$emit("closeModal");
    },
    resetModal() {
      this.$v.$reset();
      this.loadMsg1 = true;
      this.loadMsg2 = false;
      this.registrationFailed = false;
    },
    loadMsgWindow2() {
      this.generateToken();
      this.loadMsg1 = false;
      this.loadMsg2 = true;
    },
    generateToken() {
      generateToken(this.user.email)
        .then(() => {
          this.registrationFailed = false;
        })
        .catch(() => {
          this.registrationFailed = true;
        })
        .finally(() => {
          // hide spinner
        });
    }
  }
};
</script>
<style scoped>
.modal-footer {
  text-align: center;
}

#recaptcha,
#mailAuth {
  text-align: -webkit-center;
}
</style>
